import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {ICardDetails} from 'ng-payment-card/lib/domain/i-card-details';
import {environment} from '../../environments/environment';
import {SessionService} from '../Services/Session/session-service.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {

  paymentInformation: any;
  env = environment;
  constructor(private router: Router, private session: SessionService) { }

  ngOnInit(): void {
    try {
      this.env.showSteps = true;
      this.env.activeIndex = 1;
      this.env.selectedProvider = JSON.parse(this.session.getParam('selectedProvider'));
      this.env.showSteps = JSON.parse(this.session.getParam('showSteps'));
    } catch (e) {
      this.env.showSteps = false;
      this.router.navigate(['home/providers']);
    }
    this.env.showSteps = true;
    this.env.activeIndex = 1;
    // this.paymentInformation = this.ticketService.ticketInformation.paymentInformation;
  }
  processPayment($event: ICardDetails) {
    // todo si el pago fue procesado exitosamente llamar el api para agregar una persona a la cola. y mostrar dialogo de posicion actual.
    // todo llamar api para verificar si pago fue realizado y si la llamada fue realizada y finalizada con exito. de lo contrario omitir pago y proceder a espera.
    console.log($event);
    /*cardHolder: "asdfasfasdfa"
​
    cardNumber: "377720745104636"
    ​
    ccv: "123"
    ​
    expirationMonth: "11"
    ​
    expirationYear: "2024"*/
    const statusPayment = true;
    const statusCall = false;
    // this.paymentSuccess = statusPayment && !statusCall;
    /*if (this.isWaiting && this.paymentSuccess) {
    }*/
    this.router.navigate(['home/confirmation']);
  }
  nextPage() {
    if (this.paymentInformation.cardholderName && this.paymentInformation.cardholderNumber && this.paymentInformation.date && this.paymentInformation.cvv) {
      //this.ticketService.ticketInformation.paymentInformation = this.paymentInformation;
      this.router.navigate(['home/confirmation']);
    }
  }

  prevPage() {
    this.router.navigate(['home/checkout']);
  }

}
